import { styled } from '@abyss/web/tools/styled';
import { Text } from '@abyss/web/ui/Text';

export const ProviderDirectoryContentWrapped = styled('div', {
  maxWidth: '1200px',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingTop: '24px',
  paddingBottom: '24px',

  '@media (max-width: 1248px)': {
    marginLeft: '24px',
    marginRight: '0px',
    paddingTop: '24px',
    paddingBottom: '24px',
  },
  '@screen < $md': {
    marginLeft: '16px',
    marginRight: '0px',
    paddingTop: '16px',
    paddingBottom: '0px',
  },
});

export const providerDirectoryHeadingStyle = {
  paddingTop: 0,
  width: '100%',
};

export const ViewDocumentsContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  width: '1088px',
  height: '20px',
});

export const viewDocumentsTextStyle = {
  fontSize: '14px',
  lineHeight: '18px',
};

export const YearContainer = styled('div', {
  width: '1088px',
  height: '138px',
  gap: '16px',
  paddingTop: '32px',
  paddingBottom: '32px',
  display: 'flex',
  flexDirection: 'column',

  '&:not(:last-child)': {
    borderBottom: '1px solid #E5E5E6',
  },
});

export const YearBadge = styled(Text, {
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '18px',
  color: '#4B4D4F',
  padding: '6px 16px',
  borderRadius: '20px',
  backgroundColor: '#E5E5E5',
  width: 'fit-content',
});

export const DocumentLinkContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
});
